export default [
  {
    component: () => import("pages/organisations/OrganisationTeamsEdit.vue"),
    meta: {
      accessLevel: "organisation_edit",
      title: "New Organisation Team",
    },
    name: "teams-add",
    path: "/organisations/:organisationId/organisation_teams/new",
    props: true,
  },
  {
    component: () => import("pages/organisations/OrganisationTeamsEdit.vue"),
    meta: {
      accessLevel: "organisation_edit",
      title: "Edit Organisation Team",
    },
    name: "teams-edit",
    path: "/organisations/:organisationId/organisation_teams/:organisationTeamId/edit",
    props: true,
  },
];
